import React, { Component } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Avatar, Button, CssBaseline, TextField, Grid, Typography, CircularProgress, Container } from '@mui/material';
import { QueuePlayNext, DeleteForever } from '@mui/icons-material';
import { withStyles } from '@mui/styles';
import { Styles } from '../../styles/material-styles';
import { Overlay } from '../../styles/global';
import Api from '../../services/api';
import CustomizedSnackbars from '../../components/material-snackbars';
import Dropzone from 'react-dropzone';
import HeaderMenu from '../../components/header-menu';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import SimpleSelect from '../../components/select/simple';
import SimpleCheckBox from '../../components/checkbox/check';
import SimpleAutoComplete from '../../components/auto-complete/autocomplete';
import SimpleDatePicker from '../../components/date-pickers/inline';
import * as Service from '../../services/organizationchecklist.service';
import { getByOrganizationWithoutIncludes } from '../../services/organizationsetting.service'
import * as OrganizationCategoryService from '../../services/organizationcategory.service';
import * as CalledService from '../../services/called.service';
import { parseJSON } from 'date-fns';
import Footer from '../../components/footer';
import { browserHistory } from '../../helpers/history';
import { FormattedMessage, injectIntl } from 'react-intl';
import Title from '../../components/title-name';
import { DataGrid, GridToolbarFilterButton  } from '@mui/x-data-grid';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';

import ClearIcon from '@mui/icons-material/Clear'
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DialogConfirmation from '../../components/dialog-confirmation'

import SimpleAutoCompleteMultiple from "../../components/auto-complete/autocomplete-multiple-create";

import Tooltip from '@mui/material/Tooltip';
import HelpIcon from '@mui/icons-material/Help';



class OrganizationChecklistRegistration extends Component {

    constructor(props) {
        super(props);
        const intl = props.intl;
        // console.log(props);
        const { userSession, organizations } = this.props;

        this.fromProps = false
        if(this.props && this.props.location && this.props.location.state && this.props.location.state.from && this.props.location.state.from.length > 0)
            this.fromProps = true

        console.log("=== OrganizationChecklistRegistration ===")
        console.log(this.props)

        this.globalAdm = false;
        this.isClient = true;


        if (userSession.user.userrole == null) {
            Api.logoff();
        }


        userSession.user.userrole.map((item, key) => {
            if (item.role.roletype !== 3) {
                this.isClient = false;
            }
            if (item.role.roletype === 0) {
                this.globalAdm = true;
            }
        }
        );

        let categoryIdList = []

        this.initialState = {
            createdUser: userSession.user.id,
            createdAt: moment().format('YYYY/MM/DD HH:mm:ss'),
            OrganizationId: 0,
            OrganizationCategoryId: 0,
            CategoryText: '',
            OrganizationText: '',
            title: '',
            description: '',
            active: false,
            saveToAllOrganizationsInGroup: false,
            type: 2,
            Category: 0,
            CategoryId: [],
        };

        this.state = {

            item: this.initialState,
            organizations: organizations,
            files: [],
            loading: false,
            openNotification: false,
            notificationVariant: 'error',
            notificationMessage: '',
            OrganizationList: [],
            OrganizationCategoriesList: [],
            OrganizationCategories: [],
            OrganizationCategoryListForDelete: [],
            OrganizationCategoryList: [],
            displayTypes: organizations && organizations.organization && organizations.organization.caninforminitialchecklist != null ? organizations.organization.caninforminitialchecklist : false,
            TypeList: [
                { id: 1, name: this.props.intl.formatMessage({id:"initial"}) },
                { id: 2, name: this.props.intl.formatMessage({id:"final"}) },
                { id: 3, name: this.props.intl.formatMessage({id:"initial.and.final"}) }
            ],

            CategoryListForDelete: "",
            CategoryListForSelect: [],
            CategoryList: [],
            CategoryListSelect: [],
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.closeNotification = this.closeNotification.bind(this);
        this.changeValues = this.changeValues.bind(this);
        this.getByOrganizationWithoutIncludes = this.getByOrganizationWithoutIncludes.bind(this)
        this.getOrganizationCategories = this.getOrganizationCategories.bind(this)
        this.categoryDeleteModal = this.categoryDeleteModal.bind(this)
        this.openCategoryInsertModal = this.openCategoryInsertModal.bind(this)
        this.saveCategoryInsertModal = this.saveCategoryInsertModal.bind(this)
        this.setCategoryDelete = this.setCategoryDelete.bind(this)
        this.closeOrgModal = this.closeOrgModal.bind(this)
        this.NoDataRows = this.NoDataRows.bind(this)
    } // Fim - construtor

    componentWillReceiveProps(nextProps) {
        if (nextProps.location.state === "reload") {
            this.componentDidMount();
        }
    }

    componentDidMount() {
        if (this.props.location && /*this.props.location.state.internal === true &&*/ this.props.location.state != undefined) {
            this.getOrganizationsById(this.state.organizations.organization.id);
        }
        else {
            this.getOrganizations();
        }
    };

    NoDataRows = _ => {
        const intl = this.props.intl;
        return (
          <div className="MuiDataGrid-window" style={{ display: 'flex', justifyContent: 'center', top: 56, overflowY: 'auto' }} >{this.props.intl.formatMessage({id:"rows.show"})}</div>
        )
    }

    async getOrganizations() {
        this.setState({ loading: true });
        var result = await Service.getOrganizationsSimple();

        if (result.success) {
            this.setState({ loading: false, OrganizationList: result.data });

        } else {
            const intl = this.props.intl;
            this.setState({
                loading: false, openNotification: true, notificationVariant: 'error',
                notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
            });
            Api.kickoff(result);
        }
    };

    async getOrganizationsById(id) {

        this.setState({ loading: true });
        var result = await Service.getOrganizationsByIdLight(id);
        if (result.success) {
            this.setState({ loading: false, OrganizationList: [result.data] });
            await this.updateOrganization(id);
        } else {
            const intl = this.props.intl;

            this.setState({
                loading: false, openNotification: true, notificationVariant: 'error',
                notificationMessage: result.response && result.response.data && result.response.data.errors && result.response.data.errors[0] ? result.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
            });

            Api.kickoff(result);
        }
    };

    async updateOrganization(id) {
        await this.getByOrganizationWithoutIncludes(id)
        await this.getOrganizationCategories(id)
    }

    async getByOrganizationWithoutIncludes(id) {
        this.setState({ loading: true });

        var result = await getByOrganizationWithoutIncludes(id);

        if (result.success) {
            if (result.data != null) {
                this.setState({
                    loading: false,
                    displayTypes: result.data.caninforminitialchecklist != null ? result.data.caninforminitialchecklist : false
                });
            }
        } else {
            const { intl } = this.props

            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: 'error',
                notificationMessage: result.response && result.response.data && result.response.data.errors && result.response.data.errors[0] ? result.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
            });
        }
    }

    async getOrganizationCategories(id) {

        this.setState({ loading: true });

        var result = await CalledService.getCategoriesByOrganizationSimple(id);

        if (result.success) {
            if(this.isTec == false){
                if(result.data.length < 1 && id.toString().indexOf(",") == -1 ){
                    if(this.AdmOrganization){
                        this.setState({
                            loading: false, openNotification: true, notificationVariant: "error",
                            notificationMessage: this.props.intl.formatMessage({id:"called.accompaniment.notification.missing.organization.categories"}),
                            notificationLinkMove: "organizationcategories"
                        });
                    }else{
                        this.setState({
                            loading: false, openNotification: true, notificationVariant: "error",
                            notificationMessage: this.props.intl.formatMessage({id:"called.accompaniment.notification.missing.organization.categories"})
                        });
                    }
                }
                
            }
            this.setState({ loading: false, OrganizationCategoriesList: result.data, CategoryListForSelect: result.data });
        }
    };

    handleInputChange(e) {
        const name = e.target.name;
        const value = e.target.value;

        this.setState(prevState => ({
            item: {
                ...prevState.item,
                [name]: value
            }
        }));
    };

    handleSubmit = async e => {
        e.preventDefault();

        this.setState({ loading: true });
        const intl = this.props.intl
        let data = new FormData();
            

        if (this.state.item.OrganizationId === 0) {
            const intl = this.props.intl;
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: 'error',
                notificationMessage: this.props.intl.formatMessage({id:"organization.calendar.registration.missing.organization.field"}),
            });
        } else if( this.state.CategoryList == null || (this.state.CategoryList && this.state.CategoryList.length == 0)){
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: 'error',
                notificationMessage: this.props.intl.formatMessage({id:"organization.checklist.registration.missing.category"}),
            });
        } else if(this.state.item.type === 0){
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: 'error',
                notificationMessage: this.props.intl.formatMessage({id:"organization.checklist.registration.missing.type"}),
            });
        } else if( this.state.item.title.trim() === ""){
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: 'error',
                notificationMessage: this.props.intl.formatMessage({id:"organization.checklist.registration.missing.title"}),
            });
        } else if(this.state.item.description.trim() === ""){
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: 'error',
                notificationMessage: this.props.intl.formatMessage({id:"organization.checklist.registration.missing.description"}),
            });
        } else {
            if (this.isClient) {
                this.setState(prevState => ({
                    item: {
                        ...prevState.item,
                    }
                }));
            } else {
                this.setState(prevState => ({
                    item: {
                        ...prevState.item,
                    }
                }));
            }

            let idsStringCategory = "";
            if (this.state.CategoryList.length > 0) {
                this.state.CategoryList.forEach(category => idsStringCategory += `${category.id},`)
                idsStringCategory = idsStringCategory.slice(0, -1);
            }
            data.append("organizationcategoriesid", idsStringCategory);
            
            for (let key in this.state.item) {
                if (key.toString().toLowerCase().indexOf('_date') > -1 || key.toString().toLowerCase().indexOf('date') > -1 || key.toString().toLowerCase().indexOf('eventdate') > -1) {
                    data.append(key, moment(this.state.item[key]).format('YYYY/MM/DD HH:mm:ss'));
                }else if(key.toString().toLowerCase().indexOf('organizationid') > -1) {
                    data.append(key, this.state.item[key]);
                }else if(key.toString().toLowerCase().indexOf('organizationcategoryid') > -1) {
                    
                }else if(key.toString().toLowerCase().indexOf('createduser') > -1) {
                    data.append(key, this.state.item[key]);
                }else if(key.toString().toLowerCase().indexOf('createdat') > -1) {
                    data.append(key, this.state.item[key]);
                }else if(key.toString().toLowerCase().indexOf('title') > -1) {
                    data.append(key, this.state.item[key]);
                }else if(key.toString().toLowerCase().indexOf('type') > -1) {
                    data.append(key, this.state.item[key]);
                }else if(key.toString().toLowerCase().indexOf('description') > -1) {
                    data.append(key, this.state.item[key]);
                }else if(key.toString().toLowerCase().indexOf('active') > -1) {
                    data.append(key, this.state.item[key]);
                }else if(key.toString().toLowerCase().indexOf('savetoallorganizationsingroup') > -1) {
                    data.append(key, this.state.item[key]);
                }
            }


            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            };
            //console.log(parseJSON(data));
            //console.log(data);
            //console.log(JSON.stringify(data));

            Api.post('/organizationchecklists', data, config)

                .then(result => {
                    if (result.data.success) {
                        const intl = this.props.intl;
                        this.setState({
                            loading: false,
                            openNotification: true,
                            notificationVariant: 'success',
                            notificationMessage: intl.formatMessage({ id: "add.success" }),
                            item: this.initialState,
                            CategoryList: [],
                            files: []
                        });



                    }
                    else {
                        const intl = this.props.intl;
                        this.setState({
                            loading: false,
                            openNotification: true,
                            notificationVariant: 'error',
                            notificationMessage: result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })

                        });
                        Api.kickoff(result);
                    }

                })
                .catch(err => {
                    if (err.response && err.response.data && err.response.data.errors) {
                        const intl = this.props.intl;
                        this.setState({
                            loading: false,
                            openNotification: true,
                            notificationVariant: 'error',
                            notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                        });
                    }
                    else {
                        const intl = this.props.intl;
                        this.setState({
                            loading: false,
                            openNotification: true,
                            notificationVariant: 'error',
                            notificationMessage: err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" }) + err.response.data
                        });
                    }
                    Api.kickoff(err);
                });
        }



    };

    closeNotification() {
        this.setState({ openNotification: false });
    }

    changeValues(stateName, value, text = '') {
        this.setState({ loading: true });

        this.setState(prevState => ({
            item: {
                ...prevState.item,
                [stateName]: value
            }
        }));

        if (stateName === 'OrganizationId') {
            this.updateOrganization(value)
            this.setState(prevState => ({
                item: {
                    ...prevState.item,
                    'OrganizationText': text,
                }
            }));
        } else if (stateName === "CategoryId") {
            this.setState(prevState => ({
              called: {
                ...prevState.called,
                "CategoryText": text
              }
            }));
        } else if (stateName === "SellectedAllCategories") {
            this.setState(prevState => ({
              item: {
                ...prevState.item,
                "CategoryId": value ? this.state.CategoryListForSelect : []
              }
            }));
        }

        this.setState({ loading: false });
    };

    removeItem(file) {

        let array = [...this.state.files];
        let index = array.indexOf(file)
        if (index !== -1) {
            array.splice(index, 1);
            this.setState({ files: array });
        }
    }

    categoryDeleteModal = async () => {
        if (this.state.CategoryListForDelete && this.state.CategoryListForDelete.length > 0) {
          const intl = this.props.intl;
          this.setState({ loading: true });

          var categoryList = this.state.CategoryList
          var categoryDeleteList = this.state.CategoryListForDelete.split(",")

          categoryDeleteList.map(itemDelete => {
            if (itemDelete != ""){
                let returnOk = categoryList.filter(el => el.id != itemDelete)
                categoryList = returnOk
            }
          })

          this.setState({
            loading: false,
            CategoryList: categoryList,
            openNotification: true,
            notificationVariant: 'success',
            notificationMessage: intl.formatMessage({ id: "delete.sucess" })
          })
    
          /*let data = new FormData();
          data.append("organizationcategoriesid", categoryIds);
          data.append("organizationchecklistid", this.state.item.id);
    
          const intl = this.props.intl;
          await Api.post('/users/DeleteOrgOrLocalizationInUser', data)
            .then(result => {
    
              if (result.data.success) {
                var localizations = [];
    
                result.data.data.map(item => {
                  item.address.name = `( ${item.address.organization.name} ) ${item.address.name}`;
                  localizations.push(item.address)
                })
    
                this.setState({
                  loading: false,
                  OrganizationCategoryList: localizations,
                  openNotification: true,
                  notificationVariant: 'success',
                  notificationMessage: intl.formatMessage({ id: "delete.sucess" }),
                })
              }
              else {
                this.setState({
                  loading: false,
                  openNotification: true,
                  notificationVariant: 'error',
                  notificationMessage: result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
    
                });
                Api.kickoff(result);
              }
    
            })
            .catch(err => {
              if (err.response && err.response.data && err.response.data.errors) {
                this.setState({
                  loading: false,
                  openNotification: true,
                  notificationVariant: 'error',
                  notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                });
              }
              else {
                this.setState({
                  loading: false,
                  openNotification: true,
                  notificationVariant: 'error',
                  notificationMessage: intl.formatMessage({ id: "process.error" })
                });
              }
              Api.kickoff(err);
            });*/
        } else {
          this.setState({
            openNotification: true,
            notificationVariant: "error",
            notificationMessage: this.props.intl.formatMessage({id:"select.location"})
          })
        }
      }
    
      openCategoryInsertModal = async () => {
        this.setState({
          openCategoryInsertModal: !this.state.openCategoryInsertModal
        })
      }
    
      saveCategoryInsertModal = async () => {
    
        if(this.state.item.CategoryId != null && this.state.item.CategoryId.length > 0){
          
          this.setState({
            loading: true
          })

          const intl = this.props.intl;
      
          /*let data = new FormData();
      
          var categoryIds = this.state.item.CategoryId.map(item => {
            return item.id + ","
          })
      
          data.append("organizationcategoriesid", categoryIds);
          data.append("organizationchecklistid", this.state.item.id);
      
          const intl = this.props.intl;
          await Api.post('/organizationchecklistorganizationcategory/addinorganizationchecklist', data)
            .then(result => {
              if (result.data.success) {
                var categories = [];
      
                result.data.data.map(item => {
                  item.organizationcategory.name = item.organizationcategory.parentname && item.organizationcategory.parentname.length > 0 ? item.organizationcategory.parentname : item.organizationcategory.name;
                  categories.push(item.organizationcategory)
                })
      
                this.setState({
                  loading: false,
                  CategoryList: categories,
                  openNotification: true,
                  notificationVariant: 'success',
                  notificationMessage: intl.formatMessage({ id: "add.success" }),
                })
                
              }
              else {
                this.setState({
                  loading: false,
                  openNotification: true,
                  notificationVariant: 'error',
                  notificationMessage: result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
      
                });
                Api.kickoff(result);
              }
      
            })
            .catch(err => {
              if (err.response && err.response.data && err.response.data.errors) {
                this.setState({
                  loading: false,
                  openNotification: true,
                  notificationVariant: 'error',
                  notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                });
              }
              else {
                this.setState({
                  loading: false,
                  openNotification: true,
                  notificationVariant: 'error',
                  notificationMessage: intl.formatMessage({ id: "process.error" })
                });
              }
              Api.kickoff(err);
            });
      
          this.setState({
            openCategoryInsertModal: !this.state.openCategoryInsertModal,
            loading: false
          })*/

          var categories = [];
      
          this.state.item.CategoryId.map(item => {
            item.name = item.parentname && item.parentname.length > 0 ? item.parentname : item.name;
            categories.push(item)
          })

          this.setState({
            loading: false,
            CategoryList: categories,
            openNotification: true,
            notificationVariant: 'success',
            notificationMessage: intl.formatMessage({ id: "add.success" }),
            openCategoryInsertModal: !this.state.openCategoryInsertModal,
          })
        }
      }
    
      setCategoryDelete = async (org) => {
        this.setState({
            CategoryListForDelete: org + "," + this.state.CategoryListForDelete
        })
      }
    
      closeOrgModal = () => this.setState({ openCategoryInsertModal: !this.state.openCategoryInsertModal })

    render() {
        const { classes, headerMenu, actionsHeaderMenu } = this.props;
        const { item } = this.state;
        const intl = this.props.intl;

        if(Api == null) {
            var l = this.props.match.params.lang;
            document.location.href=`/${l}/unavailable`
          }

        return (
            <div className={classes.root}>
                <HeaderMenu />
                <main
                    className={clsx(classes.content, {
                        [classes.contentShift]: headerMenu.open,
                    }, classes.actionsContent, {
                        [classes.actionscontentShift]: actionsHeaderMenu.open,
                    })}
                >

                    <div className={classes.drawerHeader} />

                    <Container component='main' maxWidth='md'>
                    <Dialog
              fullWidth
              maxWidth="md"
              open={this.state.openCategoryInsertModal}
              onClose={this.closeCategoryModal}
              aria-labelledby="form-dialog-title-org-mat"
              PaperProps={{
                style: {
                  overflow: 'hidden'
                }
              }} >
              <DialogTitle id="form-dialog-title-org-mat">
                {this.props.intl.formatMessage({id:"organization.checklist.edit.new.categories"})}
                <ClearIcon onClick={this.openCategoryInsertModal} style={{ float: 'right', cursor: 'pointer' }} />
              </DialogTitle>
              <DialogContent>
                <Grid item xs={12} sm={12} >
                    <Grid container spacing={2} style={{ padding:"5px" }}>
                    <Grid item xs={12} sm={12}>
                        < SimpleAutoCompleteMultiple
                        label={this.props.intl.formatMessage({id:"menu.categories"})}
                        options={this.state.CategoryListForSelect}
                        stateName="CategoryId"
                        selected={this.state.item.CategoryId}
                        changeSelect={this.changeValues}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} style={{ justifyContent: 'flex-end' }}>
                        <Grid spacing={2} container justify="flex-end" alignItems={"center"} style={{ padding: 15, justifyContent: 'flex-end' }}>
                            <Grid item xs={12} sm={4}>
                                <SimpleCheckBox
                                label={this.props.intl.formatMessage({id:"organization.checklist.selectedAll"})}
                                name="SellectedAllCategories"
                                stateName="SellectedAllCategories"
                                changeSelect={this.changeValues}
                                selected={this.state.CategoryListForSelect.length === item.CategoryId.length}
                                disabled={this.state.CategoryListForSelect.length === 0}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Button
                                    type="button"
                                    onClick={this.openCategoryInsertModal}
                                    fullWidth >
                                    {this.props.intl.formatMessage({id:"cancel"})}
                                </Button>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Button
                                    type='submit'
                                    fullWidth
                                    variant='contained'
                                    color='primary'
                                    onClick={this.saveCategoryInsertModal}
                                >
                                    {<FormattedMessage id="save" />}
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                    </Grid>
                </Grid>
              </DialogContent>
            </Dialog>

                        <CssBaseline />
                        <div className={classes.paper} style={{ marginTop: 0 }}>
                            <Grid container spacing={6}>
                                <Grid item xs={12} sm={4}>
                                    <Button variant='outlined' color='primary' onClick={() => {
                                        this.fromProps ? this.props.history.push(`/${this.props.match.params.lang}/organization-edit`, { organizations: this.props.organizations, propTab: 5 }) : browserHistory.goBack()}
                                    }>{<FormattedMessage id="back" />}</Button>
                                </Grid>
                                <Grid item xs={12} sm={8} />
                            </Grid>
                            <Avatar className={classes.avatar}>
                                <QueuePlayNext />
                            </Avatar>
                            <Typography component='h1' variant='h5'>
                                {<FormattedMessage id="add.item" />}
                                <Title />
                            </Typography>
                            <form name='myForm' className={classes.form} onSubmit={this.handleSubmit} encType='multipart/form-data'>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12}>
                                        <SimpleSelect label={intl.formatMessage({ id: "organization" })} options={this.state.OrganizationList} stateName='OrganizationId' changeSelect={this.changeValues} selected={item.OrganizationId}  />
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <Accordion style={{marginTop: "6px", marginBottom: "10px"}}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel1a-content"
                                                id="panel1a-header"
                                            >
                                                <Typography className={classes.heading}>{intl.formatMessage({id:"categories"})}*</Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <Grid container spacing={2} xs={12} sm={12} >

                                                <Grid xs={12} sm={12} style={{ margin: '5px', padding: 10, display: 'flex', flexDirection: 'row', backgroundColor: '#eee' }} >
                                                    <Grid xs={12} sm={4} >

                                                    </Grid>
                                                    <Grid xs={12} sm={4} style={{ margin: '5px', display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }} >
                                                    <DialogConfirmation
                                                        msgButton={"Remover categoria"}
                                                        msg={"Você tem certeza que desejar remover esta categoria deste checklist?"}
                                                        msgDisagree={this.props.intl.formatMessage({id:"cancel"})}
                                                        msgAgree={this.props.intl.formatMessage({id:"yes"})}
                                                        handleConfirmation={e => this.categoryDeleteModal()}
                                                        classes={classes}
                                                        icon={<DeleteIcon />}
                                                    />
                                                    </Grid>
                                                    <Grid xs={12} sm={4} style={{ margin: '5px', display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }} >
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        fullWidth
                                                        className={classes.button}
                                                        startIcon={<AddIcon />}
                                                        onClick={e => this.openCategoryInsertModal()} >
                                                        {this.props.intl.formatMessage({id:"add.categories"})}
                                                    </Button>
                                                    </Grid>
                                                </Grid>

                                                <Grid xs={12} sm={12}
                                                    style={{
                                                    marginLeft: 5,
                                                    marginBottom: 5,
                                                    border: '3px solid #eee'
                                                    }} >
                                                    <div style={{ height: 350 }}>
                                                    <DataGrid
                                                        style={{ fontSize: 14, color: '#000' }}
                                                        className="DataGridStyle"
                                                        components={{
                                                        NoRowsOverlay: this.NoDataRows,
                                                        Toolbar: GridToolbarFilterButton,
                                                        }}
                                                        rows={this.state.CategoryList}
                                                        rowsPerPageOptions={[5]}
                                                        checkboxSelection
                                                        onSelectionModelChange={itm => {
                                                        if (itm.length > 0) {
                                                            this.setCategoryDelete(itm);
                                                        } else {
                                                            this.setState({
                                                            CategoryListForDelete: [],
                                                            })
                                                        }
                                                        }}
                                                        columns={[
                                                        { headerName: intl.formatMessage({id:"menu.categories"}), field: 'name', width: 'auto',
                                                        renderHeader: (params) => {
                                                            return (<div style={{ width: 500 }}>{params.colDef.headerName}</div>);
                                                        },
                                                        renderCell: (params) => {
                                                            return (<div style={{ marginRight: 8 }}>{params.value}</div>);
                                                        }},
                                                        ]}
                                                        HeadersVisibility="None"
                                                    />
                                                    </div>
                                                </Grid>
                                                </Grid>

                                            </AccordionDetails>
                                        </Accordion>
                                    </Grid>
                                    {this.state.displayTypes === true ? (
                                    <Grid item xs={12} sm={12}>
                                        <SimpleSelect label='Tipo:' name='type' options={this.state.TypeList} stateName='type' changeSelect={this.changeValues} selected={item.type} />
                                    </Grid>
                                    ) :
                                    (
                                    <Grid item xs={12} sm={12} style={{ display: 'none' }}>

                                    </Grid>
                                    )}
                                    <Grid item xs={12} sm={12}>
                                        <TextField inputProps={{ maxLength: 255 }} fullWidth label={intl.formatMessage({ id: "title" })} autoComplete='fname' variant='outlined' name='title' onChange={this.handleInputChange} value={item.title}  />
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                    <TextField inputProps={{ maxLength: 1000 }} fullWidth label={intl.formatMessage({ id: "description" })} autoComplete='fname' multiline='true' rows='4' variant='outlined' name='description' onChange={this.handleInputChange} value={item.description}  />
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <SimpleCheckBox label={intl.formatMessage({ id: "active" })} name='active' stateName='active' changeSelect={this.changeValues} selected={item.active} />
                                    </Grid>
                                    <Grid item xs={11} sm={11}>
                                        <SimpleCheckBox
                                        label={intl.formatMessage({id:"save.to.all.organizations.in.group"})}
                                        name='saveToAllOrganizationsInGroup'
                                        stateName='saveToAllOrganizationsInGroup' 
                                        changeSelect={this.changeValues}
                                        selected={item.saveToAllOrganizationsInGroup} />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} lg={12} style={{ marginTop: 15, display: 'flex', justifyContent: 'flex-end', marginTop: 15 }}>
                                        <Grid container justify="flex-end" style={{ justifyContent: 'flex-end' }}>
                                            <Grid item xs={12} sm={4}    >
                                                <Button 
                                                type='submit'
                                                fullWidth
                                                variant='contained'
                                                color='primary'
                                                className={classes.submit}
                                                >
                                                {<FormattedMessage id="save" />}
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </form>

                        </div>
                        {this.state.loading && (
                            <Overlay>
                                <CircularProgress color='secondary' />
                            </Overlay>
                        )}

                        <CustomizedSnackbars
                            variant={this.state.notificationVariant}
                            message={this.state.notificationMessage}
                            isOpen={this.state.openNotification}
                            toClose={this.closeNotification}
                        />
                    </Container>

                </main>
            </div>
        )
    }
}

OrganizationChecklistRegistration.propTypes = { classes: PropTypes.object.isRequired };

const mapStateToProps = state => ({
    actionsHeaderMenu: state.actionsHeaderMenu,
    headerMenu: state.headerMenu,
    userSession: state.userSession,
    organizations: state.organizations,
});

export default injectIntl(connect(mapStateToProps)(withStyles(Styles)(OrganizationChecklistRegistration)));

